/* eslint-disable no-shadow */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  ConnectFileExplorer = '[FileExplorerState] ConnectFileExplorer',
  ConnectFileExplorerSuccessful = '[FileExplorerState] ConnectFileExplorerSuccessful',
  ConnectFileExplorerFailure = '[FileExplorerState] ConnectFileExplorerFailure',
  GetFileExplorerFileList = '[FileExplorerState] GetFileExplorerFileList',
  GetFileExplorerFileListSuccessful = '[FileExplorerState] GetFileExplorerFileListSuccessful',
  GetFileExplorerFileListFailure = '[FileExplorerState] GetFileExplorerFileListFailure',
  OrderFileExplorer = '[FileExplorerState] OrderFileExplorer',
  OrderFileExplorerReset = '[FileExplorerState] OrderFileExplorerReset',
  IngestMultipleFilesExplorer = '[FileExplorerState] IngestMultipleFilesExplorer',
  IngestMultipleFilesExplorerSuccessful = '[FileExplorerState] IngestMultipleFilesExplorerSuccessful',
  IngestMultipleFilesExplorerFailure = '[FileExplorerState] IngestMultipleFilesExplorerFailure',
  GetConnectedAccount = '[FileExplorerState] GetConnectedAccount',
  GetConnectedAccountSuccessful = '[FileExplorerState] GetConnectedAccountSuccessful',
  GetConnectedAccountFailure = '[FileExplorerState] GetConnectedAccountFailure',
  GetConnectedAccountList = '[FileExplorerState] GetConnectedAccountList',
  GetConnectedAccountListSuccessful = '[FileExplorerState] GetConnectedAccountListSuccessful',
  GetConnectedAccountListFailure = '[FileExplorerState] GetConnectedAccountListFailure',
  UpdateConnectedAccountById = '[FileExplorerState] UpdateConnectedAccountById',
  UpdateConnectedAccountByIdSuccessful = '[FileExplorerState] UpdateConnectedAccountByIdSuccessful',
  UpdateConnectedAccountByIdFailure = '[FileExplorerState] UpdateConnectedAccountByIdFailure',
  DeleteConnectedAccountByProvider = '[FileExplorerState] DeleteConnectedAccountByProvider',
  DeleteConnectedAccountByProviderSuccessful = '[FileExplorerState] DeleteConnectedAccountByProviderSuccessful',
  DeleteConnectedAccountByProviderFailure = '[FileExplorerState] DeleteConnectedAccountListFailure',
  CheckFileViewPermisson = '[FileExplorerState] CheckFileViewPermisson',
  CheckFileViewPermissonSuccessful = '[FileExplorerState] CheckFileViewPermissonSuccessful',
  CheckFileViewPermissonFailure = '[FileExplorerState] CheckFileViewPermissonFailure',
  ResetDrive = '[FileExplorerState] ResetDrive'
}

export const ConnectFileExplorer = createAction(
  ActionTypes.ConnectFileExplorer,
  props<{ payload: { provider: string; accessKey?: string; secretAccessKey?: string; region?: string; bucketName?: string; } }>()
);

export const ConnectFileExplorerSuccessful = createAction(
  ActionTypes.ConnectFileExplorerSuccessful
);

export const ConnectFileExplorerFailure = createAction(
  ActionTypes.ConnectFileExplorerFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const GetFileExplorerFileList = createAction(
  ActionTypes.GetFileExplorerFileList,
  props<{ payload: { searchText?: string; folderId?: string; folderName?: string } }>()
);

export const GetFileExplorerFileListSuccessful = createAction(
  ActionTypes.GetFileExplorerFileListSuccessful,
  props<{ payload: { files: any } }>()
);

export const GetFileExplorerFileListFailure = createAction(
  ActionTypes.GetFileExplorerFileListFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const OrderFileExplorer = createAction(
  ActionTypes.OrderFileExplorer,
  props<{ payload: { folder: any } }>()
);

export const IngestMultipleFilesExplorer = createAction(
  ActionTypes.IngestMultipleFilesExplorer,
  props<{ payload: { fileIds: any; isApproved: boolean; fileMetadata?: any; categoryId: string } }>()
);

export const IngestMultipleFilesExplorerSuccessful = createAction(
  ActionTypes.IngestMultipleFilesExplorerSuccessful
);

export const IngestMultipleFilesExplorerFailure = createAction(
  ActionTypes.IngestMultipleFilesExplorerFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const GetConnectedAccount = createAction(
  ActionTypes.GetConnectedAccount
);

export const GetConnectedAccountSuccessful = createAction(
  ActionTypes.GetConnectedAccountSuccessful,
  props<{ payload: { connectedAccount: any } }>()
);

export const GetConnectedAccountFailure = createAction(
  ActionTypes.GetConnectedAccountFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const GetConnectedAccountList = createAction(
  ActionTypes.GetConnectedAccountList,
  props<{ payload: { provider: string } }>()
);

export const GetConnectedAccountListSuccessful = createAction(
  ActionTypes.GetConnectedAccountListSuccessful,
  props<{ payload: { connectedAccount: any } }>()
);

export const GetConnectedAccountListFailure = createAction(
  ActionTypes.GetConnectedAccountListFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const UpdateConnectedAccountById = createAction(
  ActionTypes.UpdateConnectedAccountById,
  props<{ payload: { id: string; isFileAccessShared: boolean } }>()
);

export const UpdateConnectedAccountByIdSuccessful = createAction(
  ActionTypes.UpdateConnectedAccountByIdSuccessful,
  props<{ payload: { isFileAccessShared: boolean } }>()
);

export const UpdateConnectedAccountByIdFailure = createAction(
  ActionTypes.UpdateConnectedAccountByIdFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const DeleteConnectedAccountByProvider = createAction(
  ActionTypes.DeleteConnectedAccountByProvider,
  props<{ payload: { provider: string } }>()
);

export const DeleteConnectedAccountByProviderSuccessful = createAction(
  ActionTypes.DeleteConnectedAccountByProviderSuccessful
);

export const DeleteConnectedAccountByProviderFailure = createAction(
  ActionTypes.DeleteConnectedAccountByProviderFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const CheckFileViewPermisson = createAction(
  ActionTypes.CheckFileViewPermisson
);

export const CheckFileViewPermissonSuccessful = createAction(
  ActionTypes.CheckFileViewPermissonSuccessful
);

export const CheckFileViewPermissonFailure = createAction(
  ActionTypes.CheckFileViewPermissonFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const OrderFileExplorerReset = createAction(
  ActionTypes.OrderFileExplorerReset
);

export const ResetDrive = createAction(
  ActionTypes.ResetDrive
);
